<div class="process-selection">
    <app-centered-scrollable-content>

        <div class="grid">
          <ng-container *ngFor="let entry of definitions">
            <div class="column">
              <div class="center">
                <app-tapable-terminal-card>
                  <app-icon-tile [iconScale]="2" [title]="entry.titleDictionaryKey | translate: [entry.titleDictionaryKey, translationService.language]" [iconCSS]="entry.titleIconCss" (click)="select(entry)">
                  </app-icon-tile>
                </app-tapable-terminal-card>
              </div>
              <p class="description" *ngIf="entry.descriptionDictionaryKey != null">{{'' | translate: [entry.descriptionDictionaryKey, translationService.language]}}</p>
            </div>
          </ng-container>
        </div>
    </app-centered-scrollable-content>
</div>
